import React from 'react'
import { Form } from 'react-bootstrap'
import useItems from '../../../hooks/use-durations'

const LabelItem = ({
    value = '',
    onChange =() => {},
    disabled
}) => {
    const [ items ] = useItems()
    if (!items) {
        return null
    }
    return (
        <Form.Control as='select' value={value} onChange={e => onChange(e.target.value)} placeholder='test' disabled={disabled}>
            <option value=''></option>
            {items.map((item, k) => (<option value={item.id} key={k}>{item.name}</option>))}
        </Form.Control>
    )
}

export default LabelItem